import { useState, useEffect, useCallback } from "react";
import { apiService } from "../api/services/apiService";
import type { GatewaySku } from "../types";

export const useGatewaySkus = () => {
  const [gatewaySkus, setGatewaySkus] = useState<GatewaySku[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchGatewaySkus = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await apiService.getGatewaySkus();
      setGatewaySkus(data);
    } catch (err: unknown) {
      console.error(err);
      setError(err instanceof Error ? err.message : "Failed to fetch gateway SKUs");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchGatewaySkus();
  }, [fetchGatewaySkus]);

  return { gatewaySkus, loading, error, refresh: fetchGatewaySkus };
};
